import { Hero } from '@/components/Hero';
import { TrustStrip } from '@/components/TrustStrip';
import { FeatureShowcase } from '@/components/FeatureShowcase';
import { PayrollSpotlight } from '@/components/PayrollSpotlight';
import { AIEngine } from '@/components/AIEngine';
import { Workflow } from '@/components/Workflow';
import { Vision } from '@/components/Vision';
import { Metrics } from '@/components/Metrics';
import { Testimonial } from '@/components/Testimonial';
import { CTA } from '@/components/CTA';

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <FeatureShowcase index="01" />
      <PayrollSpotlight index="02" />
      <Metrics index="03" />
      <AIEngine index="04" />
      <Workflow index="05" />
      <Vision index="06" />
      <Testimonial />
      <CTA />
    </>
  );
}
